/**
 * Check visiblity of an element
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export function isElementVisible(element) {
  return element.offsetWidth > 0 && element.offsetHeight > 0;
}

/**
 * Get all interactive children of an element
 *
 * @param {HTMLElement} element
 * @returns {HTMLElement[]}
 */
export function getInteractiveChildren(element) {
  /** @type {NodeListOf<HTMLElement>} */
  const children = element.querySelectorAll("a, button, input, select");

  return [...children].filter(isElementVisible);
}
